/**
 * Dynamic Yield settings utility
 * Provides centralized access to DY configuration and settings
 */

import * as DataDogLogs from '~/lib/datadog/datadog';

let hasLoggedMissingCredentials = false;

/**
 * Checks if Dynamic Yield is enabled in theme settings AND has valid credentials
 * @returns {boolean} True if DY is enabled with credentials, false otherwise
 */
export const isDynamicYieldEnabled = () => {
  const settingEnabled = window.ALLBIRDS?.settings?.dynamicYield?.enabled || false;
  const hasCredentials =
    typeof window.DY !== 'undefined' &&
    typeof window.DY.organizationId === 'string' &&
    window.DY.organizationId !== '' &&
    typeof window.DY.apiKey === 'string' &&
    window.DY.apiKey !== '';

  // Log error if enabled but credentials missing (only once to avoid spam)
  if (settingEnabled && !hasCredentials && !hasLoggedMissingCredentials) {
    hasLoggedMissingCredentials = true;
    DataDogLogs.error(
      '[Allbirds pixel] - Dynamic Yield - Error: Setting enabled but credentials missing',
      {
        dyApiKeyExists: !!window.DY?.apiKey,
        dyExists: typeof window.DY !== 'undefined',
        dyOrganizationIdExists: !!window.DY?.organizationId,
        settingEnabled,
      },
      new Error('Dynamic Yield enabled but credentials not found'),
    );
  }

  return settingEnabled && hasCredentials;
};
